// src/shared/constants/counterparty.ts
export enum CounterpartyType {
  OWNER_OF_SECURITIES = "Владелец ЦБ",
  AUTHORIZED_DEPOSITARY = "Авторизованный депонент",
  ISSUER = "Эмитент",
  REGISTRAR = "Регистратор",
  DEPOSITARY = "Депозитарий",
  EXCHANGE = "Биржа",
  AUTHORIZED_BANK = "Уполномоченный банк"
}

export enum ResidencyStatus {
  RESIDENT = "Резидент",
  NON_RESIDENT = "Нерезидент"
}

// Маппинг для преобразования в API-формат
export const COUNTERPARTY_TYPE_TO_API: Record<CounterpartyType, string> = {
  [CounterpartyType.AUTHORIZED_DEPOSITARY]: "authorized_depositary",
  [CounterpartyType.OWNER_OF_SECURITIES]: "owner_of_securities",
  [CounterpartyType.ISSUER]: "issuer",
  [CounterpartyType.REGISTRAR]: "registrar",
  [CounterpartyType.DEPOSITARY]: "depositary",
  [CounterpartyType.EXCHANGE]: "exchange",
  [CounterpartyType.AUTHORIZED_BANK]: "authorized_bank"
};

// export const RESIDENCY_STATUS_TO_API: Record<ResidencyStatus, string> = {
//   [ResidencyStatus.RESIDENT]: "Резидент",
//   [ResidencyStatus.NON_RESIDENT]: "Не резидент",
// };
export const RESIDENCY_STATUS_TO_API = {
  [ResidencyStatus.RESIDENT]: 'Резидент',
  [ResidencyStatus.NON_RESIDENT]: 'Нерезидент'
} as const;

export const API_TO_RESIDENCY_STATUS = {
  'Резидент': ResidencyStatus.RESIDENT,
  'Нерезидент': ResidencyStatus.NON_RESIDENT
} as const;
// Обратный маппинг для преобразования из API-формата
export const API_TO_COUNTERPARTY_TYPE: Record<string, CounterpartyType> = {
  "Авторизованный депонент": CounterpartyType.AUTHORIZED_DEPOSITARY,
  "Владелец ЦБ": CounterpartyType.OWNER_OF_SECURITIES,
  "Эмитент": CounterpartyType.ISSUER,
  "Регистратор": CounterpartyType.REGISTRAR,
  "Депозитарий": CounterpartyType.DEPOSITARY,
  "Биржа": CounterpartyType.EXCHANGE,
  "Уполномоченный банк": CounterpartyType.AUTHORIZED_BANK,
};

// export const API_TO_RESIDENCY_STATUS: Record<string, ResidencyStatus> = {
//   resident: ResidencyStatus.RESIDENT,
//   non_resident: ResidencyStatus.NON_RESIDENT,
// };

// Утилиты для UI
export const COUNTERPARTY_TYPE_OPTIONS = Object.values(CounterpartyType).map(type => ({
  value: type,
  label: type
}));

export const RESIDENCY_STATUS_OPTIONS = Object.values(ResidencyStatus).map(status => ({
  value: status,
  label: status
}));


